import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { RefundReasonDialogComponent } from '../refund-reason-dialog/refund-reason-dialog.component';
import { getDoc, doc } from '@angular/fire/firestore';
import { OrdersService, cardLabel } from 'src/app/services/orders.service';

@Component({
  selector: 'order-detail-popup',
  templateUrl: 'order-detail-popup.html',
  styleUrls: ['order-detail-popup.css']
})
export class OrderDetailPopup implements OnInit, OnDestroy {
  // "Visa •••• 4242 (Apple Pay) · exp 03/29" for Stripe orders (a string, not
  // a new object, so it is safe to bind).
  get cardText(): string {
    const label = cardLabel(this.data);
    return label && this.data.cardExp ? `${label} · exp ${this.data.cardExp}` : label;
  }

  editable = true;
  orderDetail: any[] = [];
  supportMessages: any[] = [];
  canRefund = false;

  getOrderDetailSub: any;
  refundReasonDialogComponentSub: any;

  constructor(
    public dialogRef: MatDialogRef<OrderDetailPopup>,
    public orderService: OrdersService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  
  ngOnDestroy(): void {
    if(this.getOrderDetailSub) this.getOrderDetailSub.unsubscribe();
    if(this.refundReasonDialogComponentSub) this.refundReasonDialogComponentSub.unsubscribe();
  }

  async ngOnInit() {
    // Load orderDetail from Firestore
    this.getOrderDetailSub = this.orderService.getOrderDetail(this.data.orderId).subscribe(products => {
      this.orderDetail = products || [];
    });
    this.supportMessages = this.data.supportMessages || [];
    // Check if the user has refund permission
    console.log("User Roles:", this.data.roles);

    this.canRefund = this.data?.roles?.includes('refund');
  }
  async refundPayment() {
    // Fetch refunded product IDs from order doc
    const orderDocRef = doc(this.orderService.afs.firestore, 'orders', this.data.orderId);
    const orderSnap = await getDoc(orderDocRef);

    let refundedQuantities: { [productId: string]: number } = {};
    if (orderSnap.exists()) {
      const orderData = orderSnap.data();
      refundedQuantities = orderData?.['refundedQuantities'] || {};
    }

    const dialogRef = this.dialog.open(RefundReasonDialogComponent, {
      width: '500px',
      data: {
        reason: '',
        orderDetail: this.orderDetail,
        refundedQuantities: refundedQuantities
      }
    });

    this.refundReasonDialogComponentSub = dialogRef.afterClosed().subscribe(async (result: { reason: string, selectedProducts: any[] }) => {
      if (!result?.reason || !result?.selectedProducts?.length) return;

      try {
        await this.orderService.refundPayment(
          this.data.orderId,
          result.reason,
          this.data.pay,
          result.selectedProducts
        );
      } catch (error) {
        console.error('Refund failed in popup:', error);
      }
    });
  }

  isArray(data) {
    return Array.isArray(data)
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
